$(document).on('click touch', '.w-accord-btn', function (e) {
    e.stopPropagation();
    toggleAccordion($(this));
});

$(document).on('click touch', '.cat-accord__head a', function (e) {
    if ($(this).closest('.cat-accord__head').hasClass('active')) {
        e.preventDefault();
        toggleAccordion($(this).siblings('.w-accord-btn'));
    }
});

function toggleAccordion(initButton) {
    var parent = $('.w-accord'),
        btn = $('.w-accord-btn');

    initButton
        .parents('.w-accord-head')
        .toggleClass('active')
        .siblings('.w-accord-body')
        .slideToggle();

    initButton
        .closest(parent)
        .toggleClass('active')
        .siblings(parent)
        .removeClass('active');

    if (!initButton.closest('.w-accord').hasClass('w-unbound')) {
        initButton
            .closest('.w-accord')
            .siblings()
            .find(btn)
            .not(initButton)
            .each(function (i) {
                $(this)
                    .parents('.w-accord-head')
                    .removeClass('active')
                    .siblings('.w-accord-body')
                    .slideUp();
            });
    }

    if (
        initButton
            .parents('.w-accord-head')
            .siblings('.w-accord-body')
            .find('.styler').length
    ) {
        refreshStyler();
    }
}
